<template>
  <ModalComponent ref="modalRef">
    <template #header>
      <slot name="header" />
    </template>

    <slot />

    <template #action>
      <n-button attr-type="submit" size="large" type="primary" @click="positiveClick">{{
        positiveText ?? 'Submit'
      }}</n-button>
      <n-button size="large" @click="negativeClick">{{ negativeText ?? 'Cancel' }}</n-button>
    </template>
  </ModalComponent>
</template>

<script lang="ts" setup>
import ModalComponent from './Modal.vue';

const modalRef = ref<InstanceType<typeof ModalComponent> | null>(null);

const { onConfirm, onCancel } = defineProps<{
  onConfirm?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  positiveText?: string;
  negativeText?: string;
}>();

const negativeClick = () => {
  if (onCancel) {
    onCancel();
  }
  modalRef.value?.closeModal();
};

const positiveClick = async () => {
  try {
    if (onConfirm) {
      await onConfirm();
    }
  } finally {
    modalRef.value?.closeModal();
  }
};

const openModal = () => {
  modalRef.value?.openModal();
};

defineExpose({ openModal });
</script>
